module.exports = "<footer class=\"app-footer footer\">\n  <span><a href=\"http://epath.me\" translate>Epath</a> &copy; 2018 creativeLabs.</span>\n  <span class=\"ml-auto\">Powered by <a href=\"http://epath.me\">Epath</a></span>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-footer/app-footer.component.html
// module id = ./src/app/components/app-footer/app-footer.component.html
// module chunks = main